import { render, staticRenderFns } from "./TheAppShell.vue?vue&type=template&id=d8b3f730"
import script from "./TheAppShell.vue?vue&type=script&lang=ts"
export * from "./TheAppShell.vue?vue&type=script&lang=ts"
import style0 from "./TheAppShell.vue?vue&type=style&index=0&id=d8b3f730&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports